<template>
  <div class="ph-compare-main ">
    <el-backtop ></el-backtop>
    <hpheader ref="headerRef" v-if="showHeader"></hpheader>


    <ph-product-list :footerHeight="footerHeight" :headerHeight="headerHeight"></ph-product-list>
<!--    <hpfooter ref="footerRef"></hpfooter>-->
  </div>
</template>

<script>

import hpheader from '@/common/hpheader.vue'
import hpfooter from '@/common/hpfooter.vue'
import positionBar from '@/components/ph-position-bar.vue'
import {session} from "@/storage/storage"
import phProductList from "@/components/compare/ph-product-list.vue"
export default {
  components: {
    positionBar,
    hpfooter,
    hpheader,
    phProductList
  },
  data() {
    return {
      showHeader: true,
      is_mounted: false,
      productc_nav: false,
      contraAngleSliderValue: 0,
      valuid:1,
      positionNav:[
        // {
        //   title:'Home',
        //   path:'/phhome',
        // },
        // {
        //   title:'Product',
        //   path:'/phproduct',
        // },
        {
          title: 'Endo GT Series',
          path: '/ph/special/endo'
        },
      ],
      channel_id:session.get("channel_id") == '' ? 1 : session.get("channel_id"),
      detail: {},
      value: '产品详情',
      hasUserInteraction: false,
      compareProductList: [],
      attrOptions: [],
      footerHeight: 0,
      headerHeight: 0,
    };
  },
  created(){
    this.ress()

  },
  async mounted() {
    let _this = this

    this.$nextTick(async () => {
      _this.is_mounted = true
      _this.resetAttrOptions()
      // _this.addCompareProduct(192)
      // _this.addCompareProduct(229)

    })

    await _this.$nextTick()

    // _this.footerHeight = _this.$refs.footerRef.$el.offsetHeight
    _this.headerHeight = _this.$refs.headerRef.$el.offsetHeight
  },
  methods: {

    ress(){
      var html = document.documentElement; //获取根元素
      var designWidth = 750; //设计稿宽度
      //html.clientWidth 视口宽度
      html.style.fontSize = html.clientWidth / designWidth * 100 + "px"; //设置字体大小
    },

    handleScroll() {
      let scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      let head_height = this.$refs.head.getHeaderHeight()
      if (scrollTop > head_height) {
        this.productc_nav = true
        this.scroll_height = scrollTop
      } else {
        this.productc_nav = false
      }
      this.$refs.head.scrollTop_change(scrollTop, 'pcquerys')
    },
    async addCompareProduct(id){
      let res = await this.$api.get_compare_product({id})
      this.compareProductList.push({
        ...res.data,
      })
      this.handleCompareData()

    },
    handleCompareData(){
      this.resetAttrOptions()
      this.compareProductList.forEach((item) => {
        if (!item.parameter) return;
        const p = item.parameter.filter(parameter => parameter.value != '')
        item.parameter = p
        item.parameter.forEach((parameter) => {
          const exists = this.attrOptions.some(attr => attr.value === parameter.attr.id);
          if (!exists) {
            this.attrOptions.push({
              value: parameter.attr.id,
              label: parameter.attr.name
            });
          }
        });
      });

      this.compareProductList.forEach((item) => {
        if (!item.parameter) item.parameter = [];
        const toAdd = [];
        this.attrOptions.forEach(attr => {
          if (attr.value === -1 || attr.value === -2) return;
          const hasAttr = item.parameter.some(p => p.attr && p.attr.id === attr.value);
          if (!hasAttr) {
            toAdd.push({
              attr: {
                id: attr.value,
                name: attr.label
              },
              value: ''
            });
          }
        });
        item.parameter.push(...toAdd);
      });
      console.log(this.compareProductList)
    },
    resetAttrOptions(){
      this.attrOptions = [
        {
          value: -2,
          label: '产品型号'
        },
        {
          value: -1,
          label: '分类'
        },
      ]
    },
  },
  beforeDestroy() {

  }
};
</script>

<style >

</style>
